
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.665 5.891a2 2 0 11-4 0 2 2 0 014 0zm-6.27 0a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zm10.94 0a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zm3.47 1.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm0 6.109a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zM5.395 12a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zm9.74 1.999a1.999 1.999 0 100-3.998 1.999 1.999 0 000 3.998zm-9.74 4.11a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zm9.74 1.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm5.87-1.2a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zm-11.34 2a2 2 0 100-4 2 2 0 000 4z"}})])
          )
        }
      }
    